import { Component, OnInit,ElementRef,ViewChild,HostListener } from '@angular/core';
import { ErrorHandler } from '../utils/error-handler';
import { Covid19Batch } from '../agptesting-newview/model/covid19Batch';
import { MessagesService } from '../messages/messages.service';
import { InvoicingItemService } from './invoicing-item.service';
import { DatePipe } from '@angular/common';
import { saveAs as saveByFileSaver } from "file-saver";
import { Paginator } from 'primeng/paginator';
@Component({
  selector: 'app-invoicing-item',
  templateUrl: './invoicing-item.component.html',
  styleUrls: ['./invoicing-item.component.css']
})
export class InvoicingItemComponent implements OnInit {
  @ViewChild('topDiv',{static : false}) elementView: ElementRef;
  selectedLabId: string;
  errorHandler: ErrorHandler = new ErrorHandler;
  loading: boolean = false;
  totalRecords: number;
  blocked: boolean = false;
  scrollableCols: any[];
  scrollableColsforPopup: any[];
  batches: Covid19Batch[];
  puid: string;
  divHeight: number;
  scrollHeight: string;
  invoicingValues: any[];
  unitPriceInput:any;
  billableSamples:any;
  batchIdPopup:boolean = false;
  senderShortName:any;
  senderShortNameForDisplay:any;
  getdetailsOfSenderPopup :any[];
  setRowdataforExport:any[] = [];
  getJsonOfCheck:string;
  listOfFile:any;
  isSelected = false;
  pageNumber:number;
  pageLimit:number;
  pageSkip:number=0;
  @ViewChild('pp',{static : false}) paginator: Paginator;
  constructor(private _messagesService: MessagesService,private invoicingItemService:InvoicingItemService,
    private datepipe: DatePipe) { }

  ngOnInit() {
    this.selectedLabId = JSON.parse(localStorage.getItem('lab')).lab._id;
    this.puid = localStorage.getItem('PUID');
    this.getDataForInvoicingItem()
    this.scrollableCols = [
      { 'header': 'Sender Short Name', 'field': 'senderShortName', 'selected': false },
      { 'header': '# Samples Received', 'field': 'samplesReceived', 'selected': false },
      { 'header': '#Drop outs', 'field': 'dropOutsSamples', 'selected': false },
      { 'header': '#Billable Samples', 'field': 'billableSamples', 'selected': false },
      { 'header': 'Unit Price [EUR]', 'field': 'unitPrice' , 'selected': false},
      { 'header': 'Total Price [EUR]', 'field': 'totalPrice' , 'selected': false},
      { 'header': 'Checkbox ', 'field': 'checkbox', 'selected': false }
    ]
    this.scrollableColsforPopup = [
    { 'header': 'Batch ID', 'field': 'batchID' },
    { 'header': 'External ID', 'field': 'externalId' },
    { 'header': 'Library ID', 'field': 'libraryId' },
    { 'header': 'Product', 'field': 'product' },
    { 'header': 'Delivery Date', 'field': 'deliveryDate' },
    { 'header': '#Sample Received', 'field': 'samplesReceived' },
    { 'header': '#Dropouts ', 'field': 'dropOutsSamples' },
    { 'header': '#Sample Invoiced', 'field': 'billableSamples' }
    ]
    this.onResize();
    this.getFilesFromAzure();
  }
  @HostListener('window:resize', ['$event'])
  onResize(event?) {
    if (this.elementView != undefined) {
      this.scrollHeight = document.documentElement.clientHeight - this.elementView.nativeElement.offsetHeight - document.getElementById("header").offsetHeight - 200+ 'px';
      this.divHeight = window.innerHeight - this.elementView.nativeElement.offsetHeight - document.getElementById("header").offsetHeight-200;
    }
  }
  getDataForInvoicingItem() {
    this.blocked = true;
    this.invoicingValues = [];
    this.invoicingItemService.getSenderBatchesForInvoicing(this.selectedLabId).subscribe(
      result => {
        if (result.data && result.data.data) {
          this.invoicingValues = result.data.data;
          this.invoicingValues.sort((d1, d2) => {
            return d1['senderShortName'].localeCompare(d2['senderShortName']);
          });
        }
        this.blocked = false;
      },
      error => {
        this.handleError(error);
      });
    }
    
    getValuesForTotalPrice(field:any,batch: any){
      if(batch.unitPrice){
         batch[field]=batch.billableSamples * batch.unitPrice;
         return batch[field].toString();
        }
    }
    getchecked(data:any,event:any){
      if(event=="" || event <= 0 || !event){
        this.isSelected=false;
        data.checkbox=false;
        let index = this.setRowdataforExport.findIndex(x => x.senderName === data.senderName);
        if(index != -1) {
          this.setRowdataforExport.splice(index,1);
        }
        data['unitPrice'] = "";
      }else{
        data['unitPrice'] = event;
      }
    }
   
    unitPriceFocusOutEvent(data:any,event:any){
      if(event.target.value && !Number.isNaN(event.target.value)){
        data['unitPrice'] = parseFloat(event.target.value).toFixed(2);
      } else{
        data['unitPrice'] = "";
      }
    }
  getValuesForPopup(field:any,batch: any){
    if( batch[field] && (field == 'deliveryDate')){
      return this.datepipe.transform(batch[field].$date, 'dd.MM.yy HH:mm');
    } else{
      return batch[field];
    }
  }


  getDialogBox(value:any){
    this.senderShortName=value['sender'];
    this.senderShortNameForDisplay = value['senderShortName'];
    this.getSenderShortNameDetails();
  }
  getSenderShortNameDetails() {
    this.paginator.first=0;
    this.pageNumber = 1;
    this.pageLimit=10;
    this.getdetailsOfSenderPopup = [];
    this.blocked = true;
    this.invoicingItemService.getBatchesForSender(this.selectedLabId, this.senderShortName, this.pageNumber.toString(), "0", this.pageLimit.toString()).subscribe(
      result => {
        if (result.data && result.data.data && result.data.data.length > 0) {
          this.batchIdPopup=true;
          this.getdetailsOfSenderPopup = result.data.data;
          this.totalRecords=result.data.metadata[0].total;
        }
        this.blocked = false;
      },
      error => {
        this.handleError(error);
      });
  }
  
  getcheckBoxData(data:any,event:any){
    if(data.unitPrice){
      if(event){
        this.setRowdataforExport.push(data);
      }else{
          let index = this.setRowdataforExport.findIndex(x => x.senderName === data.senderName);
          if(index != -1) {
            this.setRowdataforExport.splice(index,1);
            }
      }
    }else if(!data.unitPrice && event){
      data.checkbox=false
    }
  }
 
  getcheckBoxDataforAllRow(event:any){
     let count=0;
     if(this.isSelected){
      this.setRowdataforExport=[]
      this.invoicingValues.forEach (exportValues => {
        if(exportValues.unitPrice){
          exportValues.checkbox=true
          this.getcheckBoxData(exportValues,event)
        }else if(count ===0 && !exportValues.unitPrice){
          count=count+1;
        }
       })
     }else{
      this.invoicingValues.forEach (checkValue => {
        checkValue.checkbox=false
      })
      this.isSelected=false
      this.setRowdataforExport=[]
     }
     if(count > 0){
      this.invoicingValues.forEach (checkValue => {
        checkValue.checkbox=false
      })
      this.setRowdataforExport=[]
      this._messagesService.addErrorMessage({ severity: 'error', summary: 'Unit Price not found!', detail: 'Please Enter Unit Price in all row.' });
      this.isSelected=false
      event.target.checked=false
     }
  }

   exportToExcel() {
    let today = new Date();
    const formData = new FormData();
    let dateString = this.datepipe.transform(today, 'yyyyMMdd_HHmmss');
    let dataToExport = {"puid": this.puid, "exportedDate":dateString, "dataList": this.setRowdataforExport};
    let jsonString:string= JSON.stringify(dataToExport);
    let downloadType:string =  "invoicing_Item";
    this.blocked = true;
    formData.append('uploadType', downloadType);
    formData.append('requestData', jsonString);
    this.invoicingItemService.getExcelForBillableInvoice(formData).subscribe(
    result => {
          this.getFilesFromAzure();
          this.setRowdataforExport=[];
          this.invoicingValues = [];
          this.getDataForInvoicingItem();
          this.pageSkip = 0;
          this._messagesService.addSuccessMessage({
            severity: 'success', summary: 'Excel Created Succesfully',
            detail: 'Billable invoice Items Excel Files have been created',
          });
        this.blocked = false;
      },
      error => {
        this.blocked = false;
        this._messagesService.addErrorMessage({
          severity:'error',summary:'Dowmload Failed!!',
          detail:'Error occured while exporting data to excel.... Please refresh & try again!'
        })
      }

    )
  }
  getFilesFromAzure(){
    this.blocked = true;
    this.invoicingItemService.getFilesFromAzure().subscribe(result=>{
      if (result.data) {
        this.listOfFile = result.data;
      }
      this.blocked = false;
    },
    error => {
      this.blocked = false;
      this._messagesService.addErrorMessage({
        severity:'error',summary:'Download Failed!!',
        detail:'Error occured while exporting data to excel.... Please refresh & try again!'
      })
    });
  }
  downloadFile(fileObj: string){
    this.blocked = true;
    let downloadType = "invoicing_excel";
    let dataToExport = {"subfolderName": fileObj["subfolderName"], "fileName":fileObj["fileName"]};
    let jsonString:string= JSON.stringify(dataToExport);
    this.invoicingItemService.getExcelExportForBatchData(downloadType, jsonString).subscribe(
      result => {
        var blob = new Blob([result.fileContent], { type: 'application/octet-stream' });
        let blobTxt: Blob = new Blob([blob], { type: 'application/octet-stream' });
        saveByFileSaver(blobTxt, fileObj["fileName"]);
        this._messagesService.addSuccessMessage({
          severity: 'success', summary: 'Download is successful',
          detail: 'BillableInvoiceItems excel file has been downloaded',
        });
        this.blocked = false;
    },
    error => {
      this.handleError(error);
    });
  }
  private handleError(error: any) {
    this.blocked = false;
    let message = this.errorHandler.handleError(error);
    this._messagesService.addErrorMessage(message);
  }
  paginate(event) {
    if(event.page!=0){
      this.pageNumber = event.page + 1;
      this.pageSkip=(this.pageNumber-1)*10;
      this.invoicingItemService.getBatchesForSender(this.selectedLabId, this.senderShortName, this.pageNumber.toString(), this.pageSkip.toString(),this.pageLimit.toString()).subscribe(
        result => {
          if (result.data && result.data.data) {
            this.getdetailsOfSenderPopup = result.data.data;
            
          }
          this.blocked = false;
        },
        error => {
          this.handleError(error);
        });
    }else{
      this.getSenderShortNameDetails();
    }
  }
}
